var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"EventPage"}},[_c('Jumbotron',{attrs:{"heading":"About The Event","subheading":""}}),_c('b-container',[_c('b-row',[_c('div',{staticClass:"col-lg-8 blog-main pt-5"},[_c('Event')],1),_c('Sidebar')],1),_c('hr')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }